<template>
  <div class="widget-progress" />
</template>

<script lang="ts" setup>
const { value } = defineProps<{
  value: number // from 0 to 1
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.widget-progress {
  position: relative;
  background: $input;
  border-radius: 999px;
  height: 4px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: calc(v-bind(value) * 100%);
    background: $blue;
    border-radius: 999px;
    transition: width $transition-200ms-ease-in-out;
  }
}
</style>
